var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 905,
    height: 905,
    viewBox: "0 0 905 905",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 905,
    height: 905,
    rx: 160,
    fill: "#3B82F6",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 82,
    width: 741,
    height: 741,
    rx: 100,
    fill: "#3B82F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M596.43 278.857C596.43 318.085 588.426 352.766 572.42 382.901C556.413 413.035 536.386 436.068 512.338 452C536.386 467.932 556.413 490.965 572.42 521.099C588.426 551.234 596.43 585.915 596.43 625.143H618.072C620.177 625.143 621.905 625.819 623.258 627.172C624.61 628.525 625.287 630.253 625.287 632.357V646.786C625.287 648.89 624.61 650.618 623.258 651.971C621.905 653.324 620.177 654 618.072 654H286.215C284.111 654 282.383 653.324 281.03 651.971C279.677 650.618 279.001 648.89 279.001 646.786V632.357C279.001 630.253 279.677 628.525 281.03 627.172C282.383 625.819 284.111 625.143 286.215 625.143H307.858C307.858 585.915 315.861 551.234 331.868 521.099C347.875 490.965 367.902 467.932 391.95 452C367.902 436.068 347.875 413.035 331.868 382.901C315.861 352.766 307.858 318.085 307.858 278.857H286.215C284.111 278.857 282.383 278.181 281.03 276.828C279.677 275.475 279.001 273.747 279.001 271.643V257.214C279.001 255.11 279.677 253.382 281.03 252.029C282.383 250.676 284.111 250 286.215 250H618.072C620.177 250 621.905 250.676 623.258 252.029C624.61 253.382 625.287 255.11 625.287 257.214V271.643C625.287 273.747 624.61 275.475 623.258 276.828C621.905 278.181 620.177 278.857 618.072 278.857H596.43ZM567.572 278.857H336.715C336.715 288.777 337.392 298.396 338.744 307.714H565.543C566.896 298.546 567.572 288.927 567.572 278.857ZM567.572 625.143C567.572 605.604 565.017 586.855 559.907 568.894C554.797 550.933 547.996 535.302 539.504 522.001C531.013 508.7 521.506 497.277 510.985 487.733C500.465 478.189 489.493 471.088 478.07 466.429H426.218C414.795 471.088 403.823 478.189 393.302 487.733C382.781 497.277 373.275 508.7 364.783 522.001C356.292 535.302 349.491 550.933 344.38 568.894C339.27 586.855 336.715 605.604 336.715 625.143H567.572Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_69"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 346.288,
    height: 404,
    fill: "white",
    transform: "translate(279 250)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.ab1541c9535e51268deb4c66e0047f17.svg";
export { ForwardRef as ReactComponent };